import { useCallback, useEffect, useState } from "react"
import { get } from "helpers/api_helper"

// The calendar of the view in the address: one read per window (ADR 0015). Its answer is shown only for the path it was read
// for, so a new view never shows the previous one's tournaments; a reread of the same view keeps them until it lands. The page
// reads again after its own commands and when the tab regains focus (story 17), so another SuperAdmin's changes show. No path,
// no read: the page is about to take its view from the address. The queues of sending and answers are read the same way (Phase C3),
// each with the words of its own failure.
export default function useCalendarRead(path, failure = "The calendar could not be loaded.") {
  const [state, setState] = useState({})
  const [attempt, setAttempt] = useState(0)
  const reload = useCallback(() => setAttempt(value => value + 1), [])
  useEffect(() => {
    if (!path) return undefined
    let current = true
    get(path)
      .then(response => current && setState({ path, data: response?.data || null }))
      .catch(() => current && setState({ path, error: failure }))
    return () => { current = false }
  }, [path, attempt, failure])
  useEffect(() => {
    window.addEventListener("focus", reload)
    return () => window.removeEventListener("focus", reload)
  }, [reload])
  const answered = state.path === path
  return { data: answered ? state.data : null, error: answered ? state.error : null, reload }
}
